"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const generateLogo = logo => {
  if ((0, _utils.isReactNode)(logo)) {
    return logo;
  }
  const {
    icon,
    iconAlt,
    name,
    nameAlt,
    component: Component = "a",
    ...props
  } = logo;
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: "p-panel__logo"
  }, props), /*#__PURE__*/_react.default.createElement("img", {
    className: "p-panel__logo-icon",
    src: icon,
    alt: iconAlt,
    width: "24",
    height: "24"
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: "p-panel__logo-name is-fading-when-collapsed",
    src: name,
    alt: nameAlt,
    height: "16"
  }));
};

/**
 * This is a [React](https://reactjs.org/) component for panels in the
 * [Vanilla](https://vanillaframework.io/docs/) layouts.
 *
 * The Panel component can be used in many areas of the application layout. It
 * can be the child element of `AppAside`, `AppMain`, `AppNavigation`, `AppNavigationBar`
 * and `AppStatus`.
 */
const Panel = _ref => {
  let {
    forwardRef,
    children,
    className,
    contentClassName,
    controlsClassName,
    controls,
    dark,
    header,
    logo,
    stickyHeader,
    title,
    titleClassName,
    titleComponent: TitleComponent = "h4",
    titleId,
    toggle,
    wrapContent = true,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
    className: (0, _classnames.default)("p-panel", className, {
      "is-dark": dark
    }),
    ref: forwardRef
  }), logo || title || controls || toggle ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("p-panel__header", {
      "is-sticky": stickyHeader
    })
  }, logo ? generateLogo(logo) : /*#__PURE__*/_react.default.createElement(TitleComponent, {
    className: (0, _classnames.default)("p-panel__title", titleClassName),
    id: titleId
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("p-panel__controls", controlsClassName)
  }, toggle ? /*#__PURE__*/_react.default.createElement("span", {
    role: "button",
    tabIndex: 0,
    className: "p-panel__toggle",
    onClick: () => toggle.onClick(),
    onKeyDown: () => toggle.onClick()
  }, toggle.label) : null, controls)) : header, children && wrapContent ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("p-panel__content", contentClassName)
  }, children) : children);
};
var _default = exports.default = Panel;